export default __webpack_public_path__ + "static/media/progress_2.e17ad675.svg";